import { AWARD_TYPE, EVENT_OTYPE } from '@/constants/awards'
import { ENTITY_TYPE } from '@/constants/entities'
import { GOAL_EVENT_TYPE } from '@/constants/goal'

/**
 * This function tells if activity belongs to Goal, Key Result or Initiative. It returns corresponding ENTITY_TYPE
 * @param activity
 * @returns {null|string|string}
 */
export default function getActivityEntityType(activity) {
  if (activity.otype === EVENT_OTYPE.INITIATIVE_EVENT) {
    return activity.initiative.parentId ? ENTITY_TYPE.TASK : ENTITY_TYPE.INITIATIVE
  }
  const krAwardTypes = [AWARD_TYPE.CHECKIN, AWARD_TYPE.KEY_RESULT]
  switch (activity.type) {
    case GOAL_EVENT_TYPE.CHECKIN:
    case GOAL_EVENT_TYPE.KR_CREATED:
      return ENTITY_TYPE.KEY_RESULT
    case GOAL_EVENT_TYPE.CREATED:
      return ENTITY_TYPE.GOAL
    case GOAL_EVENT_TYPE.COMMENT:
    case GOAL_EVENT_TYPE.CLOSED:
    case GOAL_EVENT_TYPE.REOPENED:
      return activity.keyResultId ? ENTITY_TYPE.KEY_RESULT : ENTITY_TYPE.GOAL
    case GOAL_EVENT_TYPE.AWARD:
      return krAwardTypes.includes(activity.award.type) ? ENTITY_TYPE.KEY_RESULT : ENTITY_TYPE.GOAL
  }
  console.warn('Event type is not supported')
  return null
}
